(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      if (!this.header) return;

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.setHeaderHeight();
      this.onResizeHandler = this.setHeaderHeight.bind(this);
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      window.addEventListener('resize', this.onResizeHandler);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResizeHandler);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const headerBottom = this.headerBounds.bottom || this.header.offsetHeight;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > headerBottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.headerIsAlwaysSticky) this.hide();
      } else if (scrollTop < this.currentScrollTop && scrollTop > headerBottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.headerIsAlwaysSticky) this.reveal();
      } else if (scrollTop <= 0) {
        this.header.classList.remove('scrolled-past-header');
        this.reset();
      }

      this.currentScrollTop = Math.max(scrollTop, 0);
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeOpenElements();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    closeOpenElements() {
      const detailsElements = this.querySelectorAll('details[open]');
      detailsElements.forEach((details) => details.removeAttribute('open'));

      const searchModal = this.querySelector('details-modal');
      if (searchModal && typeof searchModal.close === 'function') {
        searchModal.close(false);
      }
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
